export default {
    name: "Countries",
    data() {
        return{
            categories: []
        }
    },
    mounted: function() {
        this.sendRequest({
            method: 'GET',
            url:'countries/list'
        }).then(({data})=> {
            this.PAISES = data;
        });
    },
    methods: {
        getCountryById(id) {
            return this.PAISES.filter(e => e.id === id)[0];
        }
    }
}